import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Persona } from 'src/app/models/personas.interface';
import { PersonaService } from 'src/app/services/persona.service';
import { ManagePersonasEditComponent } from '../edit/manage-personas-edit.component';
import { ManagePersonasData } from '../manage-personas-data';

@Component({
  selector: 'app-manage-personas-view',
  templateUrl: './manage-personas-view.component.html',
  styleUrls: ['./manage-personas-view.component.scss']
})
export class ManagePersonasViewComponent implements OnInit {
  personas: Persona[] = [];
  filteredPersonas: Persona[] = [];
  showHidden = false;
  @Input() selectedPersona!: Persona;
  @Input() personaTitles!: Persona;

  constructor(
    private personaService: PersonaService,
    private managePersonasData: ManagePersonasData
  ) {}

  @Output() newItemEvent = new EventEmitter<string>();

  ngOnInit(): void {
    this.getPersonas();
  }

  getPersonas() {
    this.personaService.getPersonas(true).subscribe({
      next: data => {
        this.personas = data ?? [];
        this.updateFilteredPersonas();
      },
      error: (error: HttpErrorResponse) => {
        console.error('There was an error while fetching the personas: ', error);
      }
    });
  }

  togglePersonaVisibility(persona: Persona) {
    const updatedPersona = { ...persona, is_hidden: !persona.is_hidden };
    this.personaService.updatePersona(updatedPersona).subscribe({
      next: () => {
        // Update the persona in the main list
        const index = this.personas.findIndex(p => p.id === persona.id);
        if (index > -1) {
          this.personas[index] = updatedPersona;
        }
        this.updateFilteredPersonas();
      },
      error: (error: HttpErrorResponse) => {
        console.error('There was an error while updating the persona: ', error);
        // Optionally, revert the change in the UI on error
      }
    });
  }

  deletePersona(persona: Persona) {
    this.personaService.deletePersona(persona).subscribe({
      next: () => {
        const index = this.personas.findIndex(p => p.id === persona.id);
        if (index > -1) {
          this.personas.splice(index, 1);
        }
        this.updateFilteredPersonas();
      },
      error: (error: HttpErrorResponse) => {
        console.error('There was an error while deleting the persona: ', error);
      }
    });
  }

  updateFilteredPersonas() {
    if (this.showHidden) {
      this.filteredPersonas = [...this.personas];
    } else {
      this.filteredPersonas = this.personas.filter(p => !p.is_hidden);
    }
  }

  onShowHiddenChange() {
    this.showHidden = !this.showHidden;
    this.updateFilteredPersonas();
  }

  showEditPersona(persona: Persona) {
    this.managePersonasData.emitViewChange({
      componentName: ManagePersonasEditComponent.name,
      persona,
      personaTitles: this.personas.flatMap(x => (x.name === persona.name ? [] : x.name))
    });
  }

  showCreateUserCard() {
    this.managePersonasData.emitViewChange({
      componentName: ManagePersonasEditComponent.name,
      personaTitles: this.personas.flatMap(x => x.name)
    });
  }
}
